import React from 'react'
import LocalAsyncStore from '../../../local-async-store'
import Container from './container'

export * from './booking-schedules'

export const apiEndpointGovEnrolments = ({ child }) => child.ccs_enrolments_path

const CCSGovEnrolments = props => {
  if (!props.child.ccs_enrolments_path)
    return (
      <Container
        {...props}
        ccs_gov_enrolments={{
          loading: false,
          data: [],
        }}
      />
    )

  const RenderLocalAsyncStore = LocalAsyncStore(
    'ccs_gov_enrolments',
    Container,
    apiEndpointGovEnrolments
  )

  return <RenderLocalAsyncStore {...props} />
}

export default CCSGovEnrolments



// WEBPACK FOOTER //
// ./src/care-enrolments/details/ccs-gov-enrolments/index.js